import React, { useState } from "react"
import MerchandiseCard from "./MerchandiseCard"
import MerchandiseCardSkeleton from "./MerchandiseCardSkeleton"
import { LoadingHelper, PaginationButton } from "../../components"
import { useFetchApi } from "../../hooks"

function Merchandise() {
  const limit = 6
  const [
    {
      data: { product, totalPage },
      loading
    },
    doFetch
  ] = useFetchApi(`/merchandises?limit=${limit}&&page=${0}`, {
    product: [],
    totalPage: 0
  })

  const handlePagination = page => {
    doFetch(`/merchandises?limit=${limit}&&page=${page.selected}`)
  }

  return (
    <div className="uk-container uk-container-large uk-margin-medium-top uk-margin-small-bottom">
      <div
        className="uk-padding-large uk-padding-remove-vertical uk-child-width-1-3"
        uk-grid="true"
      >
        {loading ? (
          <LoadingHelper className="uk-flex uk-flex-center" numOfItems={limit}>
            <MerchandiseCardSkeleton />
          </LoadingHelper>
        ) : product.length ? (
          product.map(product => (
            <div className="uk-flex uk-flex-center" key={product._id}>
              <MerchandiseCard item={product} />
            </div>
          ))
        ) : (
          <h2 className="uk-width-1-1 uk-text-center">
            Sorry, we dont have merchandise yet
          </h2>
        )}
      </div>
      {product.length ? (
        <PaginationButton
          totalPage={totalPage}
          handlePagination={handlePagination}
        />
      ) : null}
    </div>
  )
}

export default Merchandise
